import { render } from "./DashboardSidebar.vue?vue&type=template&id=50ade75e"
const script = {}

import "./DashboardSidebar.vue?vue&type=style&index=0&id=50ade75e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__